export const AIDA_DOCK_WIDTH_PX = 400
export const AIDA_DOCK_MIN_WIDTH_PX = 320
export const AIDA_DOCK_MAX_WIDTH_PX = 720
export const AIDA_FLOATING_PANEL_WIDTH_PX = 380
export const AIDA_FLOATING_PANEL_MAX_HEIGHT_PX = 600
export const AIDA_FLOATING_PANEL_INSET_PX = 16
export const AIDA_FLOATING_PANEL_SIDE_INSET_PX = 8

export function clampDockWidth(width: number, viewportWidth: number) {
  const max = Math.min(AIDA_DOCK_MAX_WIDTH_PX, Math.floor(viewportWidth * 0.5))
  const min = Math.min(AIDA_DOCK_MIN_WIDTH_PX, max)
  return Math.round(Math.min(max, Math.max(min, width)))
}
